import { pages as afToolPages } from 'modules/af_tool';
import { views as cmViews } from 'modules/cm';
import { views as ctViews } from 'modules/commission_terms';
import CompanyDetails from 'pages/Admins/CompanyDetails';
import AdminsDetails from 'pages/Admins/Details';
import AdminsRegister from 'pages/Admins/Register';
import AdviserDetails from 'pages/AdviserDetails/AdviserDetailsPage';
import AdvisersList from 'pages/AdvisersList/AdvisersListPage';
import AdvisersPage from 'pages/AdvisersPage/AdvisersPage';
import ClubsList from 'pages/Clubs/List';
import ClubRegistrationFirstStep from 'pages/Clubs/Register/FirstStep';
import SalesTriage from 'pages/DashboardB/DashboardTriage/SalesTriage';
import FirmAdminList from 'pages/FirmAdminList/FirmAdminList';
import Guides from 'pages/Guides';
import NetworksList from 'pages/Networks/List';
import AdviserAdminProfile from 'pages/Profile/AdviserAdminProfile';
import BrokerProfile from 'pages/Profile/BrokerProfile';
import ClubAdminProfile from 'pages/Profile/ClubAdminProfile';
import FirmAdminProfile from 'pages/Profile/FirmAdminProfile';
import NetworkAdminProfile from 'pages/Profile/NetworkAdminProfile';
import RegisterNetworkStep1 from 'pages/RegisterNetwork/RegisterNetworkStep1';
import { AVAILABLE_PAGES_ENUM, PERMISSION_ENUM, ROUTE_GROUPS_ENUM } from 'routes/enums';
import { PageMap, RouteMap } from 'routes/types';
import Registration from 'screens/BrokerPortal/screens/Registration/screens/Registration';
import SetPassword from 'screens/BrokerPortal/screens/Registration/screens/SetPassword/SetPassword';
import Verification from 'screens/BrokerPortal/screens/Registration/screens/Verification/Verification';
import { Dashboard as PanelDashboard } from 'screens/Panel/screens';
import * as ClubScreen from 'screens/Panel/screens/Club';
import * as FirmScreen from 'screens/Panel/screens/Firm';
import Firms from 'screens/Panel/screens/Firm/screens/List/List';
import * as NetworkScreen from 'screens/Panel/screens/Network';
import Edit from 'screens/Panel/screens/User/screens/Edit';

type PageMapProvider = (
  routeGroup: ROUTE_GROUPS_ENUM,
) => {
  provide: () => PageMap;
};

const pageMapProvider: PageMapProvider = (routeGroup: ROUTE_GROUPS_ENUM) => ({
  provide: () => {
    const map: RouteMap = {
      [ROUTE_GROUPS_ENUM.DEFAULT]: {
        [AVAILABLE_PAGES_ENUM.DASHBOARD]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: PanelDashboard,
        },
        [AVAILABLE_PAGES_ENUM.TRIAGE]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: SalesTriage,
        },
        [AVAILABLE_PAGES_ENUM.PROFILE]: {
          [PERMISSION_ENUM.USER]: AdviserAdminProfile,
          [PERMISSION_ENUM.USER_SUPPORT]: BrokerProfile,
          [PERMISSION_ENUM.USER_FIRM]: FirmAdminProfile,
          [PERMISSION_ENUM.USER_FIRM_SUPPORT]: FirmAdminProfile,
          [PERMISSION_ENUM.USER_CLUB]: ClubAdminProfile,
          [PERMISSION_ENUM.USER_NETWORK]: NetworkAdminProfile,
        },
        [AVAILABLE_PAGES_ENUM.CASE_MANAGEMENT]: {}, // to delete
      },
      [ROUTE_GROUPS_ENUM.GUIDES]: {
        [AVAILABLE_PAGES_ENUM.GUIDES]: {
          [PERMISSION_ENUM.APPLICATION]: Guides,
        },
      },
      [ROUTE_GROUPS_ENUM.APPLICATIONS]: {}, // to delete
      [ROUTE_GROUPS_ENUM.QUOTE]: {}, // to delete
      [ROUTE_GROUPS_ENUM.ESIS]: {}, // to delete
      [ROUTE_GROUPS_ENUM.NETWORKS]: {
        [AVAILABLE_PAGES_ENUM.NETWORK_REGISTER_STEP_1]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: RegisterNetworkStep1,
        },
        [AVAILABLE_PAGES_ENUM.NETWORK_LIST]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: NetworksList,
        },
        [AVAILABLE_PAGES_ENUM.NETWORK_DETAIL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: NetworkScreen.Show,
        },
      },
      [ROUTE_GROUPS_ENUM.CLUBS]: {
        [AVAILABLE_PAGES_ENUM.CLUBS_LIST]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ClubsList,
        },
        [AVAILABLE_PAGES_ENUM.CLUBS_DETAIL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ClubScreen.Show,
        },
        [AVAILABLE_PAGES_ENUM.CLUBS_REGISTER_STEP_1]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ClubRegistrationFirstStep,
        },
      },
      [ROUTE_GROUPS_ENUM.FIRMS]: {
        [AVAILABLE_PAGES_ENUM.FIRMS_LIST]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: Firms,
        },
        [AVAILABLE_PAGES_ENUM.FIRMS_DETAIL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: FirmScreen.Show,
        },
        [AVAILABLE_PAGES_ENUM.FIRM_MANAGERS]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: FirmScreen.Managers,
        },
      },
      [ROUTE_GROUPS_ENUM.REGISTER]: {
        [AVAILABLE_PAGES_ENUM.REGISTER]: {
          [PERMISSION_ENUM.NOT_LOGGED]: Registration,
          [PERMISSION_ENUM.ADMINISTRATIVE]: Registration,
        },
        [AVAILABLE_PAGES_ENUM.REGISTER_SET_PASSWORD]: {
          [PERMISSION_ENUM.NOT_LOGGED]: SetPassword,
          [PERMISSION_ENUM.ADMINISTRATIVE]: SetPassword,
        },
        [AVAILABLE_PAGES_ENUM.REGISTER_VERIFY]: {
          [PERMISSION_ENUM.NOT_LOGGED]: Verification,
          [PERMISSION_ENUM.ADMINISTRATIVE]: Verification,
        },
      },
      [ROUTE_GROUPS_ENUM.ADMINS]: {
        [AVAILABLE_PAGES_ENUM.ADMINS_LIST]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: FirmAdminList,
        },
        [AVAILABLE_PAGES_ENUM.ADMINS_DETAIL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: AdminsDetails,
        },
        [AVAILABLE_PAGES_ENUM.ADMINS_COMPANY_DETAILS]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: CompanyDetails,
        },
        [AVAILABLE_PAGES_ENUM.ADMINS_REGISTER]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: AdminsRegister,
        },
      },
      [ROUTE_GROUPS_ENUM.ADVISORS]: {
        [AVAILABLE_PAGES_ENUM.ADVISOR_SEARCH]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: AdvisersPage,
          [PERMISSION_ENUM.NOT_LOGGED]: AdvisersPage,
        },
        [AVAILABLE_PAGES_ENUM.ADVISOR_LIST]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: AdvisersList,
        },
        [AVAILABLE_PAGES_ENUM.ADVISOR_DETAIL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: AdviserDetails,
        },
      },
      [ROUTE_GROUPS_ENUM.MBC]: {}, // to delete
      [ROUTE_GROUPS_ENUM.FMA]: {}, // to delete
      [ROUTE_GROUPS_ENUM.AF_TOOL]: {
        [AVAILABLE_PAGES_ENUM.AF_TOOL]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: afToolPages.ListingPage,
        },
        [AVAILABLE_PAGES_ENUM.AF_TOOL_FORM_PAGE]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: afToolPages.FormPage,
        },
      },
      [ROUTE_GROUPS_ENUM.CM]: {
        [AVAILABLE_PAGES_ENUM.CM_INDEX]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: cmViews.cm,
        },
        [AVAILABLE_PAGES_ENUM.CM_CASE_BY_ID]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: cmViews.caseById,
        },
      },
      [ROUTE_GROUPS_ENUM.COMMISSION_TERMS]: {
        [AVAILABLE_PAGES_ENUM.COMMISSION_TERMS_INDEX]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ctViews.index,
        },
        [AVAILABLE_PAGES_ENUM.COMMISSION_TERMS_CREATE]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ctViews.create,
        },
        [AVAILABLE_PAGES_ENUM.COMMISSION_TERMS_EDIT]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: ctViews.edit,
        },
      },
      [ROUTE_GROUPS_ENUM.USER]: {
        [AVAILABLE_PAGES_ENUM.USER_EDIT]: {
          [PERMISSION_ENUM.ADMINISTRATIVE]: Edit,
        },
      },
    };

    return map[routeGroup];
  },
});

export const getPageMap = (routeGroup: ROUTE_GROUPS_ENUM): PageMap => {
  return pageMapProvider(routeGroup).provide();
};
